import {
  Box,
  Checkbox,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import {
  FeatureFlag,
  features,
  getVisibleFeatureFlags,
  toggleFeatureFlag,
} from "./features";

export function FeatureFlags() {
  const handleOnChange = (feature: FeatureFlag) => {
    toggleFeatureFlag(feature.name, { reload: true, isUserModified: true });
  };

  return (
    <Box>
      <Typography variant="h4" fontWeight={700}>
        Feature Flags
      </Typography>

      <List id="feature-flags-page-list">
        {getVisibleFeatureFlags(features).map((feature) => (
          <ListItem key={feature.name} disablePadding>
            <Checkbox
              edge="start"
              onChange={() => handleOnChange(feature)}
              checked={feature.enabled}
              slotProps={{ input: { "aria-labelledby": feature.name } }}
              sx={{ mr: 2 }}
            />

            <ListItemText
              primary={feature.name}
              slotProps={{ primary: { sx: { mt: 2 } } }}
              secondary={feature?.description}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
